import {JW_TYPE} from "./enums/RoadKillEnums";
import {AnimalHeadCount} from "./AnimalHeadCount";
import {RoadKill} from "../RoadKill";
import {gsap, TimelineLite} from "gsap";
import {RKHelper} from "../utils/RKHelper";
import {RoadKillSound} from "../sound/RoadKillSound";
import {RoadKillGameMode} from "../server/RoadKillGameMode";

export class TopAnimalHead extends PIXI.spine.Spine {
    private readonly _type: JW_TYPE;
    private _animalHeadCount: AnimalHeadCount;
    private _count: number = 0;
    private _isUpgraded: boolean = false;

    constructor(spineData: PIXI.spine.core.SkeletonData, type: JW_TYPE) {
        super(spineData);
        this._type = type;
        this.init();
    }

    public setPosition(): void {
        this.position.y = 0;
        if (this._type === JW_TYPE.RABBIT) {
            this.position.x = 218 + (1 - 1) * 144;
        } else if (this._type === JW_TYPE.DEER) {
            this.position.x = 218 + (2 - 1) * 144;
        } else if (this._type === JW_TYPE.BEAR) {
            this.position.x = 218 + (3 - 1) * 144;
        }
        if (this._animalHeadCount) {
            this._animalHeadCount.x = this.x;
        }
    }

    public playPopIn(isUpgraded: boolean): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        const animPrefix: string = this.getAnimPreFix();
        if (animPrefix) {
            const animName: string = animPrefix + (isUpgraded ? "Gold" : "") + "In";
            this._isUpgraded = isUpgraded;
            if (RoadKill.model.data.wasFeatureBuy && isUpgraded && RoadKill.model.data.mode === RoadKillGameMode.NORMAL) {
                tl.add(RKHelper.playSpineWithTimeline(this, 0, animName));
                tl.add(gsap.to(this, 0.1, {alpha: 1}), 0.24);
            } else {
                tl.add([RKHelper.playSpineWithTimeline(this, 0, animName),
                    gsap.to(this, 0.1, {alpha: 1})]);
                tl.add(() => {
                    RoadKill.soundPlayer.playTrack(RoadKillSound.SET_UP_POSTER_ADDED);
                }, this.skeleton.data.findAnimation(animName).duration / 2);
            }

        }
        return tl;
    }

    public playCountIn(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        const animPrefix: string = this.getAnimPreFix();
        if (this._animalHeadCount) {
            tl.add(this._animalHeadCount.playPopIn(animPrefix + "In"));
        }
        return tl;
    }

    public playCountOut(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        const animPrefix: string = this.getAnimPreFix();
        if (this._animalHeadCount) {
            tl.add(this._animalHeadCount.playPopOut(animPrefix + "Out"));
        }
        return tl;
    }

    public playPopOut(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        const animPrefix: string = this.getAnimPreFix();
        if (animPrefix) {
            const animName: string = animPrefix + (this._isUpgraded ? "Gold" : "") + "Out";
            tl.add([RKHelper.playSpineWithTimeline(this, 0, animName)
                , gsap.to(this, 0.1, {alpha: 1})]);
            tl.add(this.playCountOut(), 0);
        }
        return tl;
    }

    public setCount(value: number, isRestore: boolean = false): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        if (value != this._count) {
            this._count = value;
            tl.add(this._animalHeadCount.setValue(this._count, isRestore));
        }
        if (this._count < 5) {
            this._isUpgraded = false;
        }
        return tl;
    }

    public onUpgrade(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        if (!this._isUpgraded) {
            this._isUpgraded = true;
            tl.add(RKHelper.playSpineWithTimeline(this, 0, this.getAnimPreFix() + "GoldIn"));
        }
        return tl;
    }

    private init(): void {
        this.name = "JW_" + this._type;
        const animPrefix: string = this.getAnimPreFix();
        if (animPrefix) {
            this._animalHeadCount = new AnimalHeadCount(RoadKill.assetLoader.getSpineAsset(animPrefix + "Count"), this._type);
            RoadKill.topAnimalCounterView.addChild(this._animalHeadCount);
        }

        this.hide();
        this.setCount(0);
    }

    private getAnimPreFix(): string {
        let spinePath: string = "";
        if (this._type === JW_TYPE.BEAR) {
            spinePath = "bear";
        } else if (this._type === JW_TYPE.DEER) {
            spinePath = "deer";
        } else if (this._type === JW_TYPE.RABBIT) {
            spinePath = "rabbit";
        }
        return spinePath;
    }

    private hide(): void {
        this.visible = false;
        this.animalHeadCount?.hide();
    }

    get animalHeadCount(): AnimalHeadCount {
        return this._animalHeadCount;
    }

    get count(): number {
        return this._count;
    }

    get isUpgraded(): boolean {
        return this._isUpgraded;
    }

}